import { useTranslation } from "react-i18next";
import { colors, fonts, useMediaQuery } from "../../Styles";

interface ModalLayoutLvl2_props {
  content: JSX.Element | JSX.Element[];
  remainingOutputs: number;
  remainingInputs: number;
}

export default function ModalLayoutLvl2({content, remainingOutputs, remainingInputs}:ModalLayoutLvl2_props) {
  const { t } = useTranslation();
  const mobileXs = useMediaQuery(`(max-width: 805px)`);
  
  return (
    <div style={{ width: "100%", display: "grid", gridTemplateRows: mobileXs ? "2px 1fr 2px 80px" : "2px 1fr 2px 45px", gap: "5px", gridTemplateColumns: "1fr", height: "100%" }}>
      
      {/* Seperator */}
      <div style={{ gridArea: "1/1/2/2", borderBottom: "2px solid " + colors.blueDarkSecondary }} />
      
      {/* Content */}
      <div style={{ gridArea: "2/1/3/2", padding: "10px", maxHeight: "40vh", overflowY: "auto", boxSizing: "border-box", overflowX: "hidden", scrollbarWidth: "thin", scrollbarColor: colors.blueDarkSecondary + colors.transparent, display: "flex", alignItems: "center", justifyContent: "start", flexDirection: "column", gap: "15px" }}>
        {content}
      </div>
      
      {/* Seperator */}
      <div style={{ gridArea: "3/1/4/2", borderBottom: "2px solid " + colors.blueDarkSecondary }} />
      
      {/* BottomContent  */}
      <div style={{ gridArea: "4/1/5/2", padding: "10px", boxSizing: "border-box", display: "flex", flexDirection: mobileXs ? "column" : "row", gap: mobileXs ? "10px" : undefined, alignItems: "center", justifyContent: "space-around" }}>
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "10px"}}>
          <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{`${t("devices.remainingOutputs", {defaultValue:"Remaining Outputs"})}:`}</p>
          <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary, backgroundColor: remainingOutputs === 0 ? colors.systemGreen : colors.systemRed, padding: "4px 5px", borderRadius: "6px"}}>{remainingOutputs}</p>
        </div>
        <div style={{display: "flex", alignItems: "center", justifyContent: "center", gap: "10px"}}>
            <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{`${t("devices.remainingInputs", {defaultValue:"Remaining Inputs"})}:`}</p>
          <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary, backgroundColor: remainingInputs === 0 ? colors.systemGreen : colors.systemRed, padding: "4px 5px", borderRadius: "6px"}}>{remainingInputs}</p>
        </div>
      </div>

      {/* Seperator */}
      <div style={{ gridArea: "5/1/6/2", borderBottom: "2px solid " + colors.blueDarkSecondary }} />
    
    </div>
  )
}